<template>
    <ui-crud title="Documents" subtitle="Company Documents For Reference." :fetch="fetch" :groupBy="document => document.section || '-- None --'" :read-only="! canManage">

        <!-- Filters. -->
        <template #filters="{ refresh }">
            <ui-select class="mt-6" name="filter" v-model="activeFilter" :options="filterables" @input="refresh()"></ui-select>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`${item.reference} - ${item.title}`"
                :subtitle="[
                    canManage ? item.renews_at_label : null,
                    canManage ? item.published_status : null,
                    (! canManage && item.requires_acknowledgement && ! item.acknowledged) ? 'Requires Acknowledgement' : null,
                    (! canManage && item.requires_acknowledgement && item.acknowledged) ? 'Acknowledged' : null,
                ]"
                :metadata="`v${item.version}`"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <documents-form v-if="canManage" :add-item="addItem" :teams="teams"></documents-form>
            <div v-else class="text-sm text-gray-500 p-16 text-center">Select a document on the left to view it.</div>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <documents-form v-if="canManage" :item="selectedItem" :edit="setEditMode" :teams="teams"></documents-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <documents-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem" :can-manage="canManage"></documents-show>
        </template>
    </ui-crud>
</template>

<script>
import { Document, Team } from '@models'

export default {
    props: {
        canManage: Boolean,
    },
    data () {
        return {
            teams: [],
            activeFilter: 'current',
            filterables: [
                { value: 'current', label: 'Current' },
                { value: 'draft', label: 'Draft' },
                { value: 'expired', label: 'For Review' },
            ],
        }
    },
    methods: {
        async fetch () {
            return await Document.all(this.activeFilter, this.canManage)
        },
    },
    async mounted () {
        this.teams = (await Team.all()).map(x => x.toDropdown())
    },
}
</script>
